import React from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { setUserInformation } from '../../../Redux/UserInformationSlice';
import { useSelector } from 'react-redux';
import {
  CssBaseline,
  Grid,
  TextField,
  Typography,
  Button,
  useTheme,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from '@mui/material';
import { Alert } from '@mui/material';
import { Box } from '@mui/system';
import jwt_decode from 'jwt-decode';
import { setUserPermission } from '../../../Redux/UserPermissionSlice';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/system';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  '& label.MuiInputLabel-root': {
    color: 'rgba(0, 0, 0, 0.54)',
    backgroundColor: 'white',
    padding: '0 4px',
    marginLeft: '-4px',
  },
  '& .MuiInputBase-input': {
    color: 'black',
    backgroundColor: 'white',
  },
  '& .Mui-focused': {
    color: theme.palette.text.primary,
    backgroundColor: 'white',
    '& .MuiInputLabel-root': {
      color: 'rgba(0, 0, 0, 0.54)',
      backgroundColor: 'white',
    },
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(3, 0, 2),
  backgroundColor: 'white',
  color: 'black',
  '&:hover': {
    backgroundColor: 'lightgray',
  },
}));

const CustomerLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [textAgree, setTextAgree] = useState(false);
  const dispatch = useDispatch();
  const userPermission = useSelector((state) => state.userPermission.value);
  const navigate = useNavigate();
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);

  const handleLoginClick = (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    axios
      .post('/users/customerLogin', {
        username: username,
        password: password,
      })
      .then((response) => {
        const decoded = jwt_decode(response.data.token);
        dispatch(
          setUserInformation({
            userID: decoded.user_id,
            contactID: decoded.contact_id,
            token: response.data.token,
            firstName: decoded.first_name,
            lastName: decoded.last_name,
            businessName: decoded.business_name,
          })
        );
        dispatch(setUserPermission(decoded.elements));
        console.log(userPermission);
        navigate('/');
      })
      .catch((error) => {
        console.log(error);
        setError('Incorrect username or password. Please try again.');
        setIsLoading(false);
      });
  };

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  return (
    <Grid container sx={{ backgroundColor: 'gray', height: '100%' }}>
      <CssBaseline />
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: '600px', width: '100%', padding: theme.spacing(4) }}>
          {error && (
            <Alert severity='error' sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Typography component='h1' variant='h5' sx={{ color: 'white', textAlign: 'center' }}>
            Customer Login
          </Typography>
          <form onSubmit={handleLoginClick}>
            <StyledTextField
              variant='filled'
              margin='normal'
              required
              fullWidth
              id='cust-username'
              label='Username'
              name='username'
              autoComplete='username'
              value={username}
              onChange={handleUsernameChange}
              disabled={isLoading}
            />
            <StyledTextField
              variant='filled'
              margin='normal'
              required
              fullWidth
              name='password'
              label='Password'
              type='password'
              id='cust-password'
              autoComplete='current-password'
              value={password}
              onChange={handlePasswordChange}
              disabled={isLoading}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={textAgree}
                  onChange={(e) => setTextAgree(e.target.checked)}
                  name='textAgree'
                  sx={{
                    color: 'white',
                    '&.Mui-checked': { color: 'white' },
                    '&.Mui-disabled': { color: 'rgba(0, 0, 0, 0.26)' },
                  }}
                  disabled={isLoading}
                />
              }
              label={
                <Typography variant='subtitle2' align='justify' sx={{ color: 'white' }}>
                  * By checking this box, you agree to receive recurring automated promotional and
                  personalized marketing text messages (e.g. cart reminders) from Sports South at
                  the cell number used when signing up. Message frequency varies. Consent is not a
                  condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency
                  varies. Msg & data rates may apply. View Terms & Privacy. Firearms that are not
                  legally available in all 50 states will not be advertised via SMS.
                </Typography>
              }
              sx={{ mt: 2 }}
            />
            <StyledButton
              type='submit'
              fullWidth
              variant='contained'
              disabled={!username || !password || !textAgree || isLoading}
            >
              {isLoading ? <CircularProgress size={24} color='inherit' /> : 'Sign In'}
            </StyledButton>
          </form>
        </Box>
      </Grid>
    </Grid>
  );
};

export default CustomerLogin;
